module.exports = __webpack_public_path__ + "static/media/badge-apple.3636c2bc.svg";